import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Paper, Typography, makeStyles } from '@material-ui/core';
import { config } from '../../../constants';
import { Timeline, TimelineConnector, TimelineContent, TimelineDot, TimelineItem, TimelineOppositeContent, TimelineSeparator } from '@material-ui/lab';
import { AccessTime } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: '6px 16px'
  },
  secondaryTail: {
    backgroundColor: theme.palette.secondary.main
  },
  textLine: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'baseline',
    textOverflow: 'ellipsis'
  }

}));

const linkValidateTracer = (hash, t) => (
  <Link target='_blank' to={{
    pathname: `${config.REACT_APP_URL_TRAZER}/hash/${hash}` }}>{t(`infoAboutStep:validate`)}</Link>
);

const Separator = () => {
  return (
    <TimelineSeparator>
      <TimelineDot>
        <AccessTime />
      </TimelineDot>
      <TimelineConnector />
    </TimelineSeparator>
  );
};

const getOppositeContent = (timestamp) => {
  return (
    <TimelineOppositeContent>
      <Typography variant='body2' color='textSecondary'>
        {new Date(timestamp).toLocaleString()}
      </Typography>
    </TimelineOppositeContent>
  );
};

const TransactSignStep = ({ signResponse, flow }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  console.log('signResponse', flow.files);

  if (!signResponse.response) return null;
  const data = Array.isArray(signResponse.response) ? signResponse.response : [signResponse.response];
  console.log('data', data);
  return (
    <Timeline align='alternate'>
      {
        data.map((item) => {
          const file = flow.files.find((file) => file.hash === item.hash);
          const shortName = file.name.length > 50 ? file.name = file.name.substring(0, 50) + '...' : file.name;
          return (
            <TimelineItem key={item.hash}>
              {getOppositeContent(item.tx_timeStamp)}
              <Separator />
              <TimelineContent>
                <Paper elevation={3} className={classes.paper}>
                  <Typography variant='button'>
                    {shortName}
                  </Typography>
                  <div className={classes.textLine}>
                    <Typography variant='body2'>
                      {t(`infoAboutStep:hash`)}:&nbsp;
                    </Typography>
                    <Typography variant='caption'> {item.hash}</Typography>
                  </div>
                  <div className={classes.textLine}>
                    <Typography variant='body2'>
                      {t(`infoAboutStep:txHash`)}:&nbsp;
                    </Typography>
                    <Typography variant='caption'> {item.tx_hash}</Typography>
                  </div>
                  <div className={classes.textLine}>
                    <Typography variant='body2'>
                      {t(`infoAboutStep:txTimestamp`)}:&nbsp;
                    </Typography>
                    <Typography variant='caption'> {item.tx_timeStamp}</Typography>
                  </div>
                  <div className={classes.textLine}>
                    <Typography variant='body2'>
                      {t(`infoAboutStep:txBlock`)}:&nbsp;
                    </Typography>
                    <Typography variant='caption'> {item.tx_block}</Typography>
                  </div>
                  <div className={classes.textLine}>
                    <Typography variant='body2'>
                      { linkValidateTracer(item.hash, t) }
                    </Typography>
                  </div>
                </Paper>
              </TimelineContent>
            </TimelineItem>
          );
        })
      }
    </Timeline>
  );
};

TransactSignStep.propTypes = {
  signResponse: PropTypes.object.isRequired,
  flow: PropTypes.object.isRequired
};

export default TransactSignStep;
